// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAZ3r8ViFj1GfT4oZ6hdysPhUfmra0eLRo",
  authDomain: "engineercodewala-928da.firebaseapp.com",
  projectId: "engineercodewala-928da",
  storageBucket: "engineercodewala-928da.firebasestorage.app",
  messagingSenderId: "587217936337",
  appId: "1:587217936337:web:7995a90de30bf9653f8af0",
  measurementId: "G-47BD6JNX8C",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export services

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
